import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

const RecoverNotify = () => {
  const emailParam = new URLSearchParams(window.location.search).get("email");

  return (
    <div className="w-full">
      <div className="mb-4">
        <Link to="/">
          <button className="p-0 text-[#A3AED0]">
            <span className="inline-flex items-center">
              <ChevronLeft className="w-4 h-4 text-[#A3AED0]" />{" "}
              <span className="ml-1 text-[#A3AED0] font-cabin font-medium">Go Back</span>
            </span>
          </button>
        </Link>
      </div>
      <h3 className="text-[27px] cabin-500 text-[#2B3674] font-bold">Recover your Password</h3>
      <p className="text-[#A3AED0] text-[12px]">Verification Email Sent.</p>

      <p className="text-[#2B3674] font-medium mt-6 w-[100rem]">We've sent you an email at "{emailParam}"</p>
      <p className="text-[#2B3674] font-medium">Kindly check your inbox or spam folder</p>

    </div>
  )
}

export default RecoverNotify;
